<template>
  <div>
    <responsive-header :color="theme.appBar.other.color" :headerBg="theme.appBar.other.bg" :hasDrawer="false">
      <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
      <template v-slot:left-subtitle>{{ $t('myDuty.overview') }}</template>

      <template v-slot:right>
        <cal-dav-link-button />
        <v-btn v-for="(mode, ind) in modes" class="mr-1" :plain="!isActiveMode(mode.name)" icon @click="setMode(mode.name)" :key="ind">
          <v-icon :color="isActiveMode(mode.name) ? theme.appBar.other.color : ''">{{ mode.icon }}</v-icon>
        </v-btn>
      </template>
    </responsive-header>
  </div>
</template>

<script>
import ResponsiveHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import CalDavLinkButton from '@/components/buttons/CalDavLinkButton.vue';
import common from '@/mixins/common';
import MODULE_ID from '../moduleId';
import dutyMixin from '@/modules/myDuties/common/dutyMixin';
import { mapState } from 'vuex';
import configMixin from '@/mixins/configMixin';
import index from '@/modules/myDuties';

export default {
  name: 'DutyListHeader',
  mixins: [common, dutyMixin, configMixin],
  components: { ResponsiveHeader, CalDavLinkButton },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      configs: (state) => state.configs,
      stage: (state) => state.configs.stage,
    }),
    color() {
      return this.theme.appBar.other.color;
    },
    modes() {
      return this.hideDutyView
        ? [
            // { icon: 'mdi-apps', name: 'boxes' },
            //{ icon: 'mdi-view-list', name: 'list' },
            { icon: 'mdi-calendar', name: 'calendar' },
          ]
        : [
            // { icon: 'mdi-apps', name: 'boxes' },
            { icon: 'mdi-view-list', name: 'list' },
            { icon: 'mdi-calendar', name: 'calendar' },
          ];
    },
    dutiesDisplayMode: {
      get() {
        let mode = this.$store.state[MODULE_ID].dutiesDisplayMode;
        if (!mode) {
          mode = localStorage.getItem('myDuty/displayMode') || this.defaultDutyView;
          this.$store.commit(`${MODULE_ID}/setDutiesDisplayMode`, mode);
        }
        return mode;
      },
      set(value) {
        if (Array.isArray(value)) value = value[0];
        localStorage.setItem('myDuty/displayMode', value);
        this.$store.commit(`${MODULE_ID}/setDutiesDisplayMode`, value);
        console.debug('dutiesDisplayMode=', value);
      },
    },
    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },
    defaultDutyView() {
      return this.moduleConfig?.defaultDutyView ? this.moduleConfig?.defaultDutyView : 'list';
    },
    hideDutyView() {
      return !!this.moduleConfig.hideDutyView;
    },
  },
  methods: {
    back() {
      this.$router.push({ name: 'myDuties', params: {} });
    },

    isActiveMode(mode) {
      return this.dutiesDisplayMode === mode;
    },
    setMode(mode) {
      this.dutiesDisplayMode = mode;
    },
  },
};
</script>

<style scoped></style>
